import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-791adf48"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("下载打包文件")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("无打包文件")
const _hoisted_3 = { class: "tip" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tip" }, "单位是分，如50元，需填5000", -1))
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_img_uploader = _resolveComponent("img-uploader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": true,
    title: "配置",
    "before-close": _ctx.dialogHandle.close,
    width: 900,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          loading: _ctx.dialogHandle.loading,
          type: "primary",
          onClick: _ctx.dialogHandle.submit
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_el_button, {
          loading: _ctx.dialogHandle.loading,
          type: "info",
          onClick: _ctx.dialogHandle.close
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.dialogHandle.formData,
        rules: _ctx.rules,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "banner图",
            prop: "banner_img"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_img_uploader, {
                "show-img": _ctx.dialogHandle.formData.banner_img,
                onFileInfo: _ctx.dialogHandle.handleSmallFileInfo
              }, null, 8, ["show-img", "onFileInfo"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "模板id  （英文逗号分隔）",
            prop: "mat_ids"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.dialogHandle.formData.mat_ids,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogHandle.formData.mat_ids) = $event)),
                type: "textarea",
                class: "form_input"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "打包模板",
            prop: "mat_file"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                loading: _ctx.packHandle.packing,
                onClick: _ctx.packHandle.pack
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isEdit ? '重新打包' : '打包'), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              (_ctx.dialogHandle.formData.mat_file)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: _ctx.packHandle.download
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })),
              _createElementVNode("span", _hoisted_3, "注意，修改模板id，需要进行" + _toDisplayString(_ctx.isEdit ? '重新打包' : '打包'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "购买按钮文案",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.dialogHandle.formData.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogHandle.formData.title) = $event)),
                class: "form_input"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "价格",
            prop: "price"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.dialogHandle.formData.price,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogHandle.formData.price) = $event)),
                modelModifiers: { number: true },
                class: "form_input"
              }, null, 8, ["modelValue"]),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["before-close"]))
}